export const propInfo = {
  name: {
    saveSuccess: "Nom de la propriété enregistré avec succès",
    successTitle: "Succès",
    saveError: "Impossible d'enregistrer le nom de la propriété",
  },
  capacity: {
    saveSuccess: "Capacité enregistrée avec succès",
    saveError: "Impossible d'enregistrer la capacité",
  },
  location: {
    loadError: "Impossible de charger les détails de l'annonce.",
    appliedBulk: "Emplacement appliqué à {count} hébergements liés",
    saveSuccess: "Emplacement enregistré avec succès",
    partialError: "Certains hébergements n'ont pas pu être mis à jour",
    savePropertySuccess: "Emplacement de la propriété enregistré avec succès",
    saveError: "Impossible d'enregistrer l'emplacement de la propriété",
    loading: "Chargement de l'emplacement de l'annonce…",
    noUnitsTitle: "Cette annonce n'a pas encore d'unités configurées.",
    noUnitsText: "Créez au moins une unité pour configurer l'emplacement.",
    bulkNotice: "Cette modification s'appliquera aux {count} hébergements liés à {name}.",
  },
  description: {
    saveSuccess: "Description enregistrée avec succès",
    saveError: "Impossible d'enregistrer la description",
    cloneTitleNoun: "description",
    cloneItemNoun: "la description",
  },
};
